<template>
    <div id="login" class="d-flex">
        <div class="col-gauche">
            <div class="page-content">
                <div class="page-single-content">
                    <img src="../img/logo_adn83.png" class="logo-sud-thd"/>
                    <div class="img-login">
                        <img
                            src="../img/login.png"
                            alt="img"
                            style="max-width:512px !important;"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="col-droite">
            <div class="page-single-content">
                <div class="content-login">
                    <div class="row">
                        <div class="col-md-8 content-form-login">
                            <div>
                                <h1>Authentification</h1>
                                <p class="text-muted">Identifiez-vous à votre compte</p>
                            </div>
                            <div class="input-group">
                                <span class="input-group-addon">
                                  <font-awesome-icon icon="user"></font-awesome-icon>
                                </span>
                                <b-form-input
                                    v-on:keyup.enter="doLogin"
                                    v-model="email"
                                    placeholder="Identifiant"
                                ></b-form-input>
                            </div>
                            <div class="input-group">
                                <span class="input-group-addon">
                                  <font-awesome-icon icon="lock"></font-awesome-icon>
                                </span>
                                <b-form-input
                                    v-on:keyup.enter="doLogin"
                                    v-model="password"
                                    :type="'password'"
                                    placeholder="Mot de passe"
                                ></b-form-input>
                            </div>
                            <div class="col-xs-12 no-padding marginTop">
                                <router-link to="/forgot-pass">Mot de passe oublié ?</router-link>
                            </div>
                            <div class="col-xs-12 no-padding marginTop">
                                <b-button type="button" class="btn btn-primary btn-block" variant="primary" @click="doLogin()">
                                    <font-awesome-icon icon="arrow-right"></font-awesome-icon>
                                    Je m'identifie
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import Vuex from "vuex";

    Vue.use(Vuex);

    export default {
        name: "Login",
        data: () => ({
            email: '',
            password: '',
            return: ''
        }),
        methods: {
            ...Vuex.mapActions('Authentification', ['login']),
            doLogin: function () {
                var user = {
                    username: this.email,
                    password: this.password,
                    // remember_me : false,
                };
                this.login(user);
            },
        },
        computed: {
            ...Vuex.mapGetters('Authentification', ['authStatus', 'isAuthenticated']),
            ident: {
                get: function () {
                    return this.login + '/' + this.password;
                },
                set: function (value) {
                    this.return = value;
                }
            } //,
              // ...vuex.mapGetters('Dossiers', ['engagements'])
        }
    };
</script>

<style scoped></style>
